




























































































































































































































































































































































/** @format */

import { Vue, Component, Watch, Mixins } from 'vue-property-decorator';
import CustomerInfo from '../compontents/CustomerInfo.vue';
import ControlCarInfo from '../compontents/ControlCarInfo.vue';
import ParkingInfo from '../compontents/ParkingInfo.vue';
import * as routeNames from '../router-names';
import * as _ from 'lodash';
import ParkingLotSearch from '../../../components/parking-lot-search/index.vue';
import {
  queryMonthCardBuy,
  queryMonthCardCacuteTime,
  querySpacePackageSelectList,
  querySpaceSelectList,
  quertMonthCardDetail,
  quertMonthCardRenew,
  editRemark,
  masterSlave,
  getEditUser
} from '@/api/fixed-car-management';
import moment from 'moment';
// @ts-ignore hack
import Utils from '@root/utils/common';
import { carPlateReg } from '@root/utils/validator-util';
import { TraderecordPayMethodsMap } from '@/types/fixed-car-management/dictionaries';
import { carTypesMap } from '@/types/order-management/dictionaries';
import { fixedPhone } from '@root/utils/validators';
import GoBackWithCloseTab from '@root/common/mixins/go-back-with-close-tab';
import { Getter } from 'vuex-class';
import { API_SERVER } from '@root/common/config';
import { BUSINESS_LIST_PARKING_POOL } from '../../discount-management/router-names';
import { LONG_RENTAL_CAR_BUSSINESS } from '../router-names';
import { Mutation } from 'vuex-class';
import { CLOSE_CURRENT_TAB } from '@/store/mutation-types';
@Component({
  components: {
    CustomerInfo,
    ControlCarInfo,
    ParkingInfo,
    ParkingLotSearch
  }
})
export default class PropertyDetail extends Mixins(GoBackWithCloseTab) {
  @Mutation(`pageTabs/${CLOSE_CURRENT_TAB}`)
  closeCurrentTab!: Function;
  path = '/smart-parking/fixed-car-management/property-car-list/';
  get title() {
    const title = '长租车详情';
    return title;
  }

  get navs() {
    if (this.$route.query.isPool) {
      return [
        {
          label: '长租车业务办理',
          location: {
            name: BUSINESS_LIST_PARKING_POOL,
            query: {
              mobile: this.$route.query.mobile,
              name: this.$route.query.name,
              merchantId: this.$route.query.merchantId
            }
          }
        },
        {
          label: this.title
        }
      ];
    } else {
      return [
        {
          label: '长租车业务办理',
          location: {
            name: routeNames.LONG_RENTAL_CAR_BUSSINESS
          }
        },
        {
          label: this.title
        }
      ];
    }
  }
  /**
   * 支付方式
   */
  // traderecordPayMethodsList = Utils.toLabelVal(TraderecordPayMethodsMap)
  @Getter('dictionaries/newCardPaymentPayType')
  newCardPaymentPayType?: any;
  get traderecordPayMethodsList() {
    return _.filter(Utils.toLabelVal(this.newCardPaymentPayType), function(o) {
      o.label = `${o.label}`;
      return o.value != '02' && o.value != '03';
    });
  }
  carTypesList = Utils.toLabelVal(carTypesMap);
  dateFormat = 'YYYY-MM-DD';
  get operateTime() {
    if (this.filterParam.startDate && this.filterParam.endDate) {
      return [moment(this.filterParam.startDate, 'YYYY-MM-DD'), moment(this.filterParam.endDate, 'YYYY-MM-DD')];
    } else if (this.filterParam.startDate) {
      return [moment(this.filterParam.startDate, 'YYYY-MM-DD')];
    } else {
      return [];
    }
  }
  private moment = moment;
  // 新增类型
  // 要上传的数据
  filterParam: any = {
    userId: '',
    cardId: '',
    parkId: '',
    useType: '', // 车位用途 01:产权 02:出租
    packageId: '', // 套餐Id
    monthCardPackageIndex: null, // 选取套餐的索引
    parkingSpaceIndex: [],
    spaceIdList: [], // 车位ID数组
    spaceId: '', // 车位I
    period: 0, // 本次授权周期
    userName: '', //姓名
    roomNum: '', //房间号
    company: '', //单位
    phoneNum: '', //联系电话
    cardNum: '', //身份证号
    startDate: moment(new Date(), 'YYYY-MM-DD'), //开始日期
    endDate: '', // 结束日期
    payType: '', //支付方式
    price: '', // 价格
    plateList: [
      {
        plate: '',
        carType: '01',
        brand: '',
        color: ''
      }
    ],
    images: [],
    desc: ''
  };

  //  错误信息
  errorMsg = {
    parkId: {
      validateStatus: '',
      help: ''
    },
    packageId: {
      validateStatus: '',
      help: ``
    }, // 套餐Id
    spaceId: {
      validateStatus: '',
      help: ``
    }, // 车位I
    period: {
      validateStatus: '',
      help: ``
    }, // 本次授权周期
    userName: {
      validateStatus: '',
      help: ``
    }, //姓名
    phoneNum: {
      validateStatus: '',
      help: ``
    }, //联系电话
    timeDate: {
      validateStatus: '',
      help: ``
    }, // 结束日期
    payType: {
      validateStatus: '',
      help: ``
    }, //支付方式
    plateList: [
      {
        plate: '',
        carType: '01',
        brand: '',
        color: ''
      }
    ]
  };

  // 月卡套餐列表
  private monthCardPackage: any = [];
  // 车位信息
  private parkingSpace: any = [];
  // Authorized vehicles 授权车辆，后面可能要修改
  private authorizedVehicles: any = [
    {
      plate: '',
      carType: '',
      carBrand: '',
      carColor: ''
    }
  ];
  get getSpaceNameList() {
    let spaceIdlist: any,
      spaceIdName: any = [];
    if (this.filterParam.spaceIdList.length > 0) {
      spaceIdlist = this.filterParam.spaceIdList;
    } else {
      spaceIdlist = [this.filterParam.spaceId];
    }
    spaceIdlist = Array.from(new Set(spaceIdlist));
    const arr: any = [];
    spaceIdlist.forEach((item: any) => {
      this.parkingSpace.filter((items: any) => {
        if (items.spaceId === item) {
          arr.push(items);
        }
      });
    });
    arr.forEach((items: any) => {
      spaceIdName.push(items.category);
    });
    spaceIdName = Array.from(new Set(spaceIdName));
    return spaceIdName;
  }
  // eslint-disable-next-line getter-return
  get getSpaceList() {
    let spaceIdlist: any;
    if (this.filterParam.spaceIdList.length > 0) {
      spaceIdlist = this.filterParam.spaceIdList;
    } else {
      spaceIdlist = [this.filterParam.spaceId];
    }
    spaceIdlist = Array.from(new Set(spaceIdlist));
    const arr: any = [];
    spaceIdlist.forEach((item: any) => {
      this.parkingSpace.filter((items: any) => {
        if (items.spaceId === item) {
          arr.push(items);
        }
      });
    });
    return arr;
  }
  get getSpaceListNum() {
    let spaceIdlist: any;
    if (this.filterParam.spaceIdList.length > 0) {
      spaceIdlist = this.filterParam.spaceIdList;
    } else {
      spaceIdlist = [this.filterParam.spaceId];
    }
    spaceIdlist = Array.from(new Set(spaceIdlist));
    let num: number = 0;
    spaceIdlist.forEach((item: any) => {
      this.parkingSpace.filter((items: any) => {
        if (items.spaceId === item) {
          num = Number(items.number) + num;
        }
      });
    });
    return num || '';
  }
  /*
   *
   * 生命周期
   * */
  private monthCardCacuteTimeDebounce: any = null;
  private created() {
    this.monthCardCacuteTimeDebounce = _.debounce(this.monthCardCacuteTime, 800);
    this.init();
  }
  private isDetail = false;
  // 初始化数据
  private init() {
    if (this.$route.query.isDetail) {
      this.isDetail = true;
    } else {
      this.isDetail = false;
    }
    this.filterParam.cardId = (this.$route.query.cardId as string) || '';
    this.filterParam.useType = this.$route.query.useType as string;
  }

  // 初始化接口 获取月卡套餐
  private async spacePackageSelectList() {
    const load: any = this.$message.loading('正在加载月卡套餐', 0);
    try {
      const { parkId, useType } = this.filterParam;
      const { status, msg, data = [] } = await querySpacePackageSelectList({
        parkId,
        useType
      });
      if (status === '9999' && data.length > 0) {
        this.monthCardPackage = data;
        this.filterParam.monthCardPackageIndex = 0;
        this.parkingSpace = [];
        if (this.filterParam.useType === '01') {
          this.filterParam.spaceIdList = [];
        } else {
          this.filterParam.spaceId = '';
        }
        this.filterParam.images = data.images || [];
      } else {
        this.monthCardPackage = [];
        this.parkingSpace = [];
        this.filterParam.monthCardPackageIndex = null;
        if (this.filterParam.useType === '01') {
          this.filterParam.spaceIdList = [];
        } else {
          this.filterParam.spaceId = '';
        }
        this.$message.error('没有获取到套餐信息');
      }
    } catch (error) {
      this.$message.error((error && error.msg) || '系统繁忙，请稍后再试');
      console.log('querySpacePackageSelectList 接口错误');
    } finally {
      load();
    }
  }

  /**
   * 提交信息
   */
  private isSub = false;
  private async submitClick() {
    if (this.isSub) return;
    this.isSub = true;
    const load: any = this.$message.loading('正在提交信息，请稍等');
    try {
      let {
        useType,
        parkId,
        packageId,
        spaceIdList,
        spaceId,
        userName,
        roomNum,
        company,
        phoneNum,
        cardNum,
        plateList,
        period,
        startDate,
        endDate,
        payType,
        price,
        cardId,
        userId
      } = this.filterParam;
      if (this.filterParam.useType === '01') {
        if (spaceId) {
          spaceIdList.push(spaceId);
        }
      }
      spaceIdList = Array.from(new Set(spaceIdList));
      if (!parkId) {
        this.errorMsg.parkId.help = '车场必填';
        this.$message.error('车场必填');
        return (this.errorMsg.parkId.validateStatus = 'error');
      } else {
        this.errorMsg.parkId.help = '';
        this.errorMsg.parkId.validateStatus = '';
      }
      if (!packageId) {
        this.errorMsg.packageId.help = '套餐必填';
        this.$message.error('套餐必填');
        this.errorMsg.packageId.validateStatus = 'error';
        return false;
      } else {
        this.errorMsg.packageId.help = '';
        this.errorMsg.packageId.validateStatus = '';
      }
      if (spaceIdList.length === 0) {
        this.errorMsg.spaceId.help = '车位号必填';
        this.$message.error('车位号必填');
        this.errorMsg.spaceId.validateStatus = 'error';
        return false;
      } else {
        this.errorMsg.spaceId.help = '';
        this.errorMsg.spaceId.validateStatus = '';
      }
      if (!period) {
        this.errorMsg.period.help = '授权周期必填';
        this.$message.error('授权周期必填');
        this.errorMsg.period.validateStatus = 'error';
        return false;
      } else {
        this.errorMsg.period.help = '';
        this.errorMsg.period.validateStatus = '';
      }
      if (!userName) {
        this.errorMsg.userName.help = '姓名必填';
        this.$message.error('姓名必填');
        this.errorMsg.userName.validateStatus = 'error';
        return false;
      } else {
        this.errorMsg.userName.help = '';
        this.errorMsg.userName.validateStatus = '';
      }
      // if (!phoneNum) {
      //   this.errorMsg.phoneNum.help = '联系方式必填'
      //   this.$message.error('联系方式必填')
      //   this.errorMsg.phoneNum.validateStatus = 'error'
      //   return false
      // } else if (!/^((1[0-9]\d{9}))$/.test(phoneNum)) {
      //   this.errorMsg.phoneNum.help = '请填写正确的手机号'
      //   this.$message.error('请填写正确的手机号')
      //   this.errorMsg.phoneNum.validateStatus = 'error'
      //   return false
      // } else {
      //   this.errorMsg.phoneNum.help = ''
      //   this.errorMsg.phoneNum.validateStatus = ''
      // }
      if (!startDate || !endDate) {
        this.errorMsg.timeDate.help = '授权日期必填';
        this.$message.error('授权日期必填');
        this.timeDate.phoneNum.validateStatus = 'error';
        return false;
      } else {
        this.errorMsg.timeDate.help = '';
        this.errorMsg.timeDate.validateStatus = '';
      }
      if (!payType) {
        this.errorMsg.payType.help = '支付方式必选';
        this.$message.error('支付方式必选');
        return (this.errorMsg.payType.validateStatus = 'error');
      } else {
        this.errorMsg.payType.help = '';
        this.errorMsg.payType.validateStatus = '';
      }
      startDate = moment(startDate).format('YYYY-MM-DD');
      for (let i = 0; i < plateList.length; i++) {
        if (!plateList[i].plate) {
          // return this.$message.error(`请输入授权车辆，第 ${i + 1} 项的车牌`)
        } else if (!carPlateReg.test(plateList[i].plate)) {
          return this.$message.error(`授权车辆，第 ${i + 1} 项的车牌输入有误`);
        }
      }
      if (cardId && userId) {
        const { status, msg, data } = await quertMonthCardRenew(
          JSON.stringify({
            cardId,
            userId,
            useType,
            parkId,
            packageId,
            spaceIdList,
            userName,
            roomNum,
            company,
            phoneNum,
            cardNum,
            plateList,
            period,
            startDate,
            endDate,
            payType,
            price
          })
        );
        if (status === '9999') {
          this.$message.success(data);
          this.$router.replace({
            name:
              this.filterParam.useType === '02' ? routeNames.LONG_RENTAL_CAR_BUSSINESS : routeNames.PROPERTY_CAR_LIST
          });
          this.goBack();
        } else {
          this.$message.error(msg);
        }
      } else {
        const { status, msg, data } = await queryMonthCardBuy(
          JSON.stringify({
            useType,
            parkId,
            packageId,
            spaceIdList,
            userName,
            roomNum,
            company,
            phoneNum,
            cardNum,
            plateList,
            period,
            startDate,
            endDate,
            payType,
            price
          })
        );
        if (status === '9999') {
          this.$message.success(data);
          this.$router.replace({
            name:
              this.filterParam.useType === '02' ? routeNames.LONG_RENTAL_CAR_BUSSINESS : routeNames.PROPERTY_CAR_LIST
          });
          this.goBack();
        } else {
          this.$message.error(msg);
        }
      }
    } catch (error) {
      this.$message.error((error && error.msg) || '系统繁忙，请稍后再试');
      console.log('queryMonthCardBuy   接口错误');
    } finally {
      load();
      this.isSub = false;
    }
  }

  /**
   * 获取车位信息
   */
  private async spaceSelectList() {
    const load: any = this.$message.loading('正在加载车位信息', 0);
    try {
      const { parkId, useType, packageId } = this.filterParam;
      const { status, msg, data = [] } = await querySpaceSelectList({
        parkId,
        useType,
        packageId
      });
      if (status === '9999' && data.length > 0) {
        this.parkingSpace = data;
        if (this.filterParam.useType === '01') {
          this.filterParam.spaceIdList = [data[0].spaceId];
        } else {
          this.filterParam.spaceId = data[0].spaceId;
        }
      } else {
        this.parkingSpace = [];
        if (this.filterParam.useType === '01') {
          this.filterParam.spaceIdList = [];
        } else {
          this.filterParam.spaceId = '';
        }
        this.$message.error('没有获取到车位信息');
      }
    } catch (error) {
      this.$message.error((error && error.msg) || '系统繁忙，请稍后再试');
      console.log('querySpaceSelectList 接口错误');
    } finally {
      load();
    }
  }

  /**
   * 获取结束时间，以及价格
   */
  @Watch('getSpaceList')
  onChangeGetSpaceList(newVal: any) {
    if (this.isSub) {
      this.monthCardCacuteTimeDebounce(this.filterParam.period || null, null);
    }
  }
  /**
   * 计算价格
   */
  private async monthCardCacuteTime(period: any, endDate: any) {
    if (this.isDetail) return;
    const load: any = this.$message.loading('正在计算价格', 0);
    try {
      const { price, periodNum } = this.monthCardPackage[this.filterParam.monthCardPackageIndex];
      const { startDate } = this.filterParam;
      const spaceCount = this.getSpaceList.length;
      const { status, msg, data = {} } = await queryMonthCardCacuteTime({
        packagePrice: price,
        packagePeriod: periodNum,
        spaceCount,
        period: period || '',
        startDate: moment(startDate).format('YYYY-MM-DD'),
        endDate: endDate || ''
      });
      if (status === '9999') {
        const { endDate, price } = data;
        this.filterParam.endDate = endDate;
        this.filterParam.price = price;
      } else {
        this.filterParam.endDate = null;
        this.filterParam.price = 0;
      }
    } catch (error) {
      this.$message.error((error && error.msg) || '系统繁忙，请稍后再试');
      console.log('queryMonthCardCacuteTime   接口错误');
    } finally {
      load();
    }
  }

  /**
   * 添加车牌信息
   */
  private addAuthorizedVehiclesClick() {
    this.filterParam.plateList.push({
      plate: '',
      carType: '01',
      brand: '',
      color: ''
    });
  }

  /**
   * 删除车牌信息
   */
  private delAuthorizedVehicles(index: number) {
    this.filterParam.plateList.splice(index, 1);
  }

  /**
   * 过滤车位信息
   */
  private filterOption(input: any, option: any) {
    return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0;
  }
  // 当套餐变化
  @Watch('filterParam.monthCardPackageIndex')
  onChangeMonthCardPackageIndex(newVal: any, oldVal: any) {
    if (newVal !== null && newVal !== undefined) {
      if (this.filterParam.cardId === '') {
        this.filterParam.packageId = this.monthCardPackage[newVal].packageId;
        this.filterParam.period = this.monthCardPackage[newVal].periodNum;
        this.spaceSelectList();
        this.monthCardCacuteTimeDebounce(this.filterParam.period, null);
      }
    } else {
      this.filterParam.packageId = '';
      this.parkingSpace = [];

      if (this.filterParam.useType === '01') {
        this.filterParam.spaceIdList = [];
      } else {
        this.filterParam.spaceId = '';
      }
    }
  }

  // 当车场发生变化
  @Watch('filterParam.parkId')
  onChangeParkId(newVal: any, oldVal: any) {
    if (newVal) {
      if (this.filterParam.cardId === '') {
        this.spacePackageSelectList();
      }
      this.getMasterSlave();
    } else {
      this.monthCardPackage = [];
      this.parkingSpace = [];
      this.filterParam.monthCardPackageIndex = null;
      if (this.filterParam.useType === '01') {
        this.filterParam.spaceIdList = [];
      } else {
        this.filterParam.spaceId = '';
      }
    }
  }
  //period
  @Watch('filterParam.period')
  onChangePeriod(newVal: any, oldVal: any) {
    if (newVal % this.filterParam.period === 0) {
      this.errorMsg.period.validateStatus = '';
      this.errorMsg.period.help = '';
      this.monthCardCacuteTimeDebounce(newVal, null);
    } else {
      this.filterParam.period = oldVal;
    }
  }

  /**
   * 看看cardId !== '' 的时候调用详情
   * @param date
   * @param dateString
   */

  @Watch('filterParam.cardId')
  onChangeCardId(newVal: any) {
    if (newVal !== '') {
      this.getMonthDetail();
    }
  }

  /**
   * 获取详情
   */
  async getMonthDetail() {
    try {
      const { cardId } = this.filterParam;
      const { status, msg, data = {} } = await quertMonthCardDetail({ cardId });
      if (status === '9999') {
        this.filterParam.cardId = data.cardId;
        this.filterParam.parkId = data.parkId;
        this.filterParam.packageId = data.spacePackage.packageId;
        this.filterParam.monthCardPackageIndex = 0;
        this.monthCardPackage = [data.spacePackage];
        // this.filterParam.spaceIdList = [data.spaceList[0].spaceId]

        data.spaceList.forEach((item: any) => {
          this.filterParam.spaceIdList.push(item.spaceId);
        });
        if (this.filterParam.spaceIdList.length === 1) {
          this.filterParam.spaceId = data.spaceList[0].spaceId;
        }
        this.parkingSpace = data.spaceList;
        this.filterParam.userName = data.spaceUser.userName;
        this.filterParam.userId = data.spaceUser.userId;
        this.filterParam.roomNum = data.spaceUser.roomNum;
        this.filterParam.company = data.spaceUser.company;
        this.filterParam.phoneNum = data.spaceUser.phoneNum;
        this.filterParam.cardNum = data.spaceUser.cardNum;
        this.filterParam.plateList = [];
        if (data.plateList && data.plateList.length > 0) {
          data.plateList.forEach((model, index) => {
            this.filterParam.plateList.push({ ...model, checked: model.masterCar == '01' });
          });
        }
        if (this.isDetail === true) {
          this.filterParam.endDate = data.endDate;
          this.filterParam.startDate = data.startDate;
          this.filterParam.payType = data.payType;
          this.filterParam.price = data.price;
        } else {
          this.filterParam.endDate = data.renewEndDate;
          this.filterParam.startDate = data.renewStartDate;
          this.filterParam.price = data.renewPrice;
        }
        this.filterParam.period = data.spacePackage.periodNum;
        // 备注
        this.filterParam.desc = data.desc;
        this.filterParam.photos = data.spaceUser.photos || [];
      } else {
        this.$message.error(msg);
      }
    } catch (error) {
      this.$message.error((error && error.msg) || '系统繁忙，请稍后再试');
    }
  }

  // 时间变化
  onChangeTime(date: any, dateString: any) {
    const [startDate, endDate] = dateString;
    this.filterParam.startDate = startDate;
    this.filterParam.endDate = endDate;
    this.monthCardCacuteTime(null, endDate);
  }

  // 客户信息
  consList = [
    {
      title: '姓名',
      prop: 'consName',
      consName: ''
    },
    {
      title: '房号/住址',
      prop: 'consRoom',
      consRoom: ''
    },
    {
      title: '联系电话',
      prop: 'consTel',
      consTel: ''
    },
    {
      title: '身份证号',
      prop: 'consCardId',
      consCardId: ''
    }
  ];
  // 车位信息
  parkingInfo = [
    {
      prop: 'useType',
      label: '车位用途'
    },
    {
      prop: 'packageArea',
      label: '授权区域'
    },
    {
      prop: 'fixed',
      label: '是否固定车位'
    },
    {
      prop: 'period',
      label: '授权周期'
    },
    {
      prop: 'type',
      label: ' 卡类型'
    },
    {
      prop: 'price',
      label: ' 套餐单价'
    }
  ];

  handleChange() {}
  // 备注
  iconDescing = false;
  textareaDisabled = true;
  async editTextarea() {
    if (this.iconDescing) return;
    this.iconDescing = true;
    try {
      const res = await editRemark({ cardId: this.filterParam.cardId, desc: this.filterParam.desc });
      console.log(res);
      this.textareaDisabled = true;
    } catch (error) {
      console.log(error);
    } finally {
      this.iconDescing = false;
    }
  }
  previewVisible: boolean = false;
  previewImage: string = '';
  API_SERVER = API_SERVER;
  handlePreviewCancel() {
    this.previewVisible = false;
  }
  async handlePreview(url: string) {
    this.previewImage = url;
    this.previewVisible = true;
  }
  defaultMasterCar: string = '00';
  //根据车场获取是否启用优先车辆
  async getMasterSlave() {
    try {
      const { data } = await masterSlave({ parkId: this.filterParam.parkId });
      this.defaultMasterCar = data || '00';
    } catch (error) {
      this.$message.error((error && error.msg) || '未获取到是否启用优先车辆信息');
    }
  }
  goBack() {
    this.closeCurrentTab();
    if (this.$route.query.isPool) {
      this.$router.replace({
        name: BUSINESS_LIST_PARKING_POOL,
        query: {
          mobile: this.$route.query.mobile,
          name: this.$route.query.name,
          merchantId: this.$route.query.merchantId
        }
      });
    } else {
      this.$router.replace({
        name: LONG_RENTAL_CAR_BUSSINESS
      });
    }
  }

  // 修改基本信息
  iconeditdetail = false;
  detailDisabled = true;
  async editdetailInfo() {
    // 编辑信息方法
    if (this.filterParam.userName.trim() === '') {
      return this.$message.warning('姓名必填');
    }
    if (this.iconDescing) return;
    this.iconDescing = true;

    try {
      const res = await getEditUser({
        cardId: this.filterParam.cardId,
        userName: this.filterParam.userName,
        roomNum: this.filterParam.roomNum,
        phoneNum: this.filterParam.phoneNum,
        cardNum: this.filterParam.cardNum,
        company: this.filterParam.company
      });
      console.log(res);
      this.detailDisabled = true;
    } catch (error) {
      console.log(error);
    } finally {
      this.iconDescing = false;
    }
  }
}
